module.exports = __webpack_public_path__ + "img/infoguidance_mov_01.07ee0c7c.jpg";